import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';

import { AffiliateCookieSetterComponent } from './components/public/affiliateCookieSetter/affiliateCookieSetter.component';
import { RouteQueryGuard } from './v2/guards/route-query.guard';
import { OnNavigationLeaveGuard } from './v2/guards/on-navigation-leave.guard';
import { WaiverSignComponent } from './v2/components/public/waiver-builder/waiver-sign.component';
import { WaiverSignRedirectComponent } from './v2/components/public/waiver-builder/waiver-sign-redirect.component';
import { EnvelopeSignComponent } from './v2/components/public/waiver-builder/envelope-sign.component';

const routes: Routes = [
  {
    path: '', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'affiliate/:af', component: AffiliateCookieSetterComponent
  },
  {
    path: 'affiliate/:af/:co', component: AffiliateCookieSetterComponent
  },
  {
    path: 'waiver',
    loadChildren: () => import('./waiver/waiver.module').then(m => m.WaiverModule)
  },
  {
    path: 'sign-waiver/:waiverId', component: WaiverSignComponent,
  },
  {
    path: 'w/:payload', component: WaiverSignRedirectComponent,
  },
  {
    path: 'envelope/:envelopeId', component: EnvelopeSignComponent,
  },
  {
    // Public, read-only. The token is a possession capability; see
    // complete-waivers-analytics-guard.ts for why it must stay out of
    // analytics.
    path: 'complete-waivers/:token',
    loadComponent: () => import('./v2/components/public/complete-waivers/complete-waivers.component')
      .then(m => m.CompleteWaiversComponent)
  },
  {
    // Public. One participant's signing link; the token is a bearer
    // capability kept out of analytics the same way (see
    // complete-waivers-analytics-guard.ts) and out of Referer headers.
    path: 'participant-waivers/:token',
    loadComponent: () => import('./v2/components/public/participant-waivers/participant-waivers.component')
      .then(m => m.ParticipantWaiversComponent),
    // Confirms before leaving a waiver with unsaved input (the component's canDeactivate).
    canDeactivate: [OnNavigationLeaveGuard],
  },
  {
    path: 's/:token',
    loadComponent: () => import('./components/public/short-link-redirect/short-link-redirect.component')
      .then(m => m.ShortLinkRedirectComponent)
  },
  {
    // Public Waiver Kiosk: a company's walk-up signing page. The code is an
    // opaque per-company lookup key, not a bearer secret (the page only
    // lists waivers that are public-readable anyway), so none of the
    // token-page guards apply. See docs/waiver-kiosk-plan.md.
    path: 'waivers/:kioskCode',
    loadComponent: () => import('./v2/components/public/waiver-kiosk/waiver-kiosk.component')
      .then(m => m.WaiverKioskComponent)
  },
  {
    path: 'legal',
    loadChildren: () => import('./components/public/legal/legal.module').then(m => m.LegalModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./v2/components/public/company-registration/company-registration.module')
      .then(m => m.CompanyRegistrationModule)
  },
  {
    path: 'book/:templateID',
    canActivate: [RouteQueryGuard],
    loadChildren: () => import('./v2/components/public/booking-flow-public.module')
      .then(m => m.BookingFlowPublicModule)
  },
  {
    path: 'demo-booking',
    loadComponent: () => import('./v2/components/public/demo-booking/demo-booking.component')
      .then(m => m.DemoBookingComponent)
  },
  {
    path: '',
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
